import { green, grey, red } from "@mui/material/colors";
import { commonDataGridStyles } from "../../styles/DataGridStyles";
import utilColors from "../../styles/utilColors";

const styles = {
  viewSelectForm: {
    width: "25%",
    mt: "5px",
    ml: "2px",
    paddingX: "5px",
  },
  viewSelectSelect: {
    height: "35px",
  },
  cloudIconTextBox: {
    display: "inline",
    fontSize: "large",
  },
  scriptBox: {
    display: "flex",
    flexDirection: "row",
    mb: "0px",
    pb: "0px",
    mt: "auto",
  },
};

export const submitRequestDialogStyles = {
  gridContainer: {
    padding: "7px",
    width: "50vw",
  },
  formControl: { width: "100%" },
};

export const DbSoftwareBuildsStyles = {
  mainBox: { mx: "5px" },
  gridContainer: {
    mt: "-10px",
    height: "10vh",
    alignItems: "center",
  },
  dataGridBoxStyles: (colors) => ({
    height: "86.7vh",
    width: "99.2%",
    ...commonDataGridStyles(colors),
  }),
};

export const OsImageBuildsStyles = {
  mainBox: { mx: "5px" },
  gridContainer: {
    mt: "-10px",
    height: "10vh",
    alignItems: "center",
  },
  dataGridBoxStyles: (colors) => ({
    height: "86.7vh",
    width: "99.2%",
    ...commonDataGridStyles(colors),
  }),
};

export const buildDetailedPanelStyles = {
  mainGrid: { py: 2, height: "100%", boxSizing: "border-box" },
  paper: {
    flex: 1,
    mx: "auto",
    width: "99%",
    p: 1,
    height: "100%",
    border: `1px solid ${grey[800]}`,
  },
  otherDetailsHorizontalBox: {
    display: "flex",
    direction: "row",
    mt: "5px",
  },
  qaResultsTypography: {
    alignSelf: "center",
    textAlign: "center",
    mr: "5px",
  },
  qaResultsBox: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: 1,
  },
  otherDeatilsItemKeyTypography: {
    minWidth: "130px",
    maxWidth: "130px",
    flexShrink: 0,
  },
  osImageOtherDetialsItemKeyTypography: {
    minWidth: "70px",
    maxWidth: "70px",
    flexShrink: 0,
  },
  logsButton: {
    m: "0 0 0 2px",
    width: "100%",
  },
  osImageQaButton: {
    m: "0 0 0 2px",
    width: "100px",
  },
  otherDetailsButton: {
    m: "0 0 0 5px",
    width: "20%",
  },
  scriptPathBox: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    flexGrow: 1,
    minWidth: 0,
  },
  stepMainBox: {
    display: "flex",
    flexDirection: "row",
    border: `1px solid ${grey[400]}`,
    p: "0px 0px 0px 10px",
    m: "3px",
    borderRadius: "4px",
  },
  stepName: (stepStatus) => {
    const stepColorMap = {
      COMPLETED: green[300],
      FAILED: red[300],
      RUNNING: utilColors.white,
    };
    return { mt: "7px", color: stepColorMap?.[stepStatus] };
  },
  stepErrorIcon: { ml: "7px", mt: "7px" },
  retryIcon: { mr: "5px" },
};
export default styles;
